module.exports = __webpack_public_path__ + "img/icon_dbxm@2x.ea9d1bcc.png";